/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { BadRequestResponse } from '../model/badRequestResponse';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { GetOfficeWithdrawalQuestionsResponse } from '../model/getOfficeWithdrawalQuestionsResponse';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary Get withdrawal questions
 */
export const useGetOfficeWithdrawalQuestionsHook = () => {
  const getOfficeWithdrawalQuestions =
    useCustomClient<GetOfficeWithdrawalQuestionsResponse>();

  return (
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getOfficeWithdrawalQuestions(
      { url: `/api/js/office_withdrawal/questions`, method: 'GET', signal },
      options
    );
  };
};

export const getGetOfficeWithdrawalQuestionsQueryKey = () => {
  return [`/api/js/office_withdrawal/questions`] as const;
};

export const useGetOfficeWithdrawalQuestionsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetOfficeWithdrawalQuestionsHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetOfficeWithdrawalQuestionsHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOfficeWithdrawalQuestionsQueryKey();

  const getOfficeWithdrawalQuestions = useGetOfficeWithdrawalQuestionsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetOfficeWithdrawalQuestionsHook>>>
  > = ({ signal }) => getOfficeWithdrawalQuestions(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOfficeWithdrawalQuestionsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOfficeWithdrawalQuestionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOfficeWithdrawalQuestionsHook>>>
>;
export type GetOfficeWithdrawalQuestionsQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get withdrawal questions
 */
export const useGetOfficeWithdrawalQuestions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetOfficeWithdrawalQuestionsHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetOfficeWithdrawalQuestionsHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetOfficeWithdrawalQuestionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetOfficeWithdrawalQuestionsSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetOfficeWithdrawalQuestionsHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetOfficeWithdrawalQuestionsHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOfficeWithdrawalQuestionsQueryKey();

  const getOfficeWithdrawalQuestions = useGetOfficeWithdrawalQuestionsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetOfficeWithdrawalQuestionsHook>>>
  > = ({ signal }) => getOfficeWithdrawalQuestions(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOfficeWithdrawalQuestionsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOfficeWithdrawalQuestionsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOfficeWithdrawalQuestionsHook>>>
>;
export type GetOfficeWithdrawalQuestionsSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get withdrawal questions
 */
export const useGetOfficeWithdrawalQuestionsSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetOfficeWithdrawalQuestionsHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetOfficeWithdrawalQuestionsHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetOfficeWithdrawalQuestionsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
